import { RootState } from 'common/redux/core/root.reducer';

export const getAvatar = (state: RootState) => state.appUser.avatar;

export const getUserName = (state: RootState) => state.appUser.name;

export const getUserId = (state: RootState) => state.appUser.id;

export const getUserEmail = (state: RootState) => state.appUser.emailId;

export const getUserInfoSelector = (state: RootState) => state.appUser.userInfo;
